"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentEditorContext = void 0;
var react_1 = __importStar(require("react"));
var editor_1 = __importDefault(require("@draft-js-plugins/editor"));
var draft_js_1 = require("draft-js");
var draftjs_md_converter_1 = require("draftjs-md-converter");
require("draft-js/dist/Draft.css");
require("@draft-js-plugins/image/lib/plugin.css");
require("@draft-js-plugins/focus/lib/plugin.css");
require("./styles.css");
var components_1 = require("./components");
var hooks_1 = require("./hooks");
var plugins_1 = __importDefault(require("./plugins"));
var styles_1 = require("./styles");
var constants_1 = require("./constants");
exports.ContentEditorContext = react_1.createContext({});
function ContentEditor(_a) {
    var value = _a.value, onChange = _a.onChange, onImagesChange = _a.onImagesChange, placeholder = _a.placeholder, readOnly = _a.readOnly, style = _a.style, baseClassName = _a.className, children = _a.children;
    var editorRef = react_1.useRef(null);
    var _b = hooks_1.useContentEditorState({
        value: value,
        readOnly: readOnly,
    }), editorState = _b.editorState, setEditorState = _b.setEditorState;
    var handleReset = react_1.useCallback(function () {
        var newState = draft_js_1.EditorState.push(editorState, draft_js_1.ContentState.createFromText(""), "insert-characters");
        setEditorState(newState);
    }, [editorState, setEditorState]);
    var plugins = react_1.useMemo(function () { return plugins_1.default(readOnly); }, [readOnly]);
    function getBlockStyle(block) {
        var blockType = block.getType();
        switch (blockType) {
            case "blockquote":
                return "RichEditor-blockquote";
            case "atomic":
                return "RichEditor-image";
            default:
                return "";
        }
    }
    function getMDFromState() {
        var contentState = editorState.getCurrentContent();
        var rawObject = draft_js_1.convertToRaw(contentState);
        var md = draftjs_md_converter_1.draftjsToMd(rawObject, constants_1.CONTENT_EDITOR_CUSTOM_CONFIGS.draftJsToMd);
        return md;
    }
    function focusEditor() {
        (editorRef === null || editorRef === void 0 ? void 0 : editorRef.current) && editorRef.current.focus();
    }
    function toggleBlockType(blockType) {
        setEditorState(function (editorState) {
            return draft_js_1.RichUtils.toggleBlockType(editorState, blockType);
        });
    }
    function toggleInlineStyle(inlineStyle) {
        setEditorState(function (editorState) {
            return draft_js_1.RichUtils.toggleInlineStyle(editorState, inlineStyle);
        });
    }
    function toggleLinkStyle() {
        var link = window.prompt("Pega aquí tu link");
        var selection = editorState.getSelection();
        var editorContent = editorState.getCurrentContent();
        var contentWithEntity = editorContent.createEntity("LINK", "MUTABLE", {
            url: link,
        });
        var entityKey = contentWithEntity.getLastCreatedEntityKey();
        var newEditorState = draft_js_1.EditorState.push(editorState, contentWithEntity, "apply-entity");
        setEditorState(draft_js_1.RichUtils.toggleLink(newEditorState, selection, entityKey));
        var newMDString = getMDFromState();
        onChange && onChange(newMDString);
        setTimeout(function () { return focusEditor(); }, 0);
        return "handled";
    }
    function handleKeyCommand(command) {
        var newState = draft_js_1.RichUtils.handleKeyCommand(editorState, command);
        if (newState) {
            setEditorState(newState);
            return "handled";
        }
        return "not-handled";
    }
    function handlePastedFiles(files) {
        var reader = new FileReader();
        reader.onloadend = function () {
            var url = reader.result;
            var editorContent = editorState.getCurrentContent();
            var contentWithEntity = editorContent.createEntity("IMAGE", "IMMUTABLE", {
                src: url,
            });
            var entityKey = contentWithEntity.getLastCreatedEntityKey();
            var newState = draft_js_1.AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, " ");
            setEditorState(newState);
            onImagesChange && onImagesChange({ file: files[0], url: url });
        };
        if (files[0])
            reader.readAsDataURL(files[0]);
        return "handled";
    }
    var className = (baseClassName === null || baseClassName === void 0 ? void 0 : baseClassName.editor) || "";
    var contentState = editorState.getCurrentContent();
    var md = getMDFromState();
    if (!contentState.hasText()) {
        if (contentState.getBlockMap().first().getType() !== "unstyled") {
            className += "RichEditor-hidePlaceholder";
        }
    }
    return (react_1.default.createElement(exports.ContentEditorContext.Provider, { value: {
            editorState: editorState,
            onToggleInlineStyle: toggleInlineStyle,
            onToggleBlockType: toggleBlockType,
            onToggleLinkStyle: toggleLinkStyle,
            handleReset: handleReset,
        } },
        react_1.default.createElement(styles_1.Container, { className: baseClassName === null || baseClassName === void 0 ? void 0 : baseClassName.root, style: style === null || style === void 0 ? void 0 : style.root },
            children,
            react_1.default.createElement(styles_1.EditorContainer, { className: className, style: style === null || style === void 0 ? void 0 : style.editor, onClick: focusEditor },
                react_1.default.createElement(editor_1.default, { ref: editorRef, editorState: editorState, onChange: function (editorState) {
                        setEditorState(editorState);
                        onChange && onChange(md, handleReset);
                    }, blockStyleFn: getBlockStyle, handleKeyCommand: handleKeyCommand, handlePastedFiles: handlePastedFiles, blockRenderMap: draft_js_1.DefaultDraftBlockRenderMap, customStyleMap: constants_1.CONTENT_EDITOR_CUSTOM_CONFIGS.styleMap, placeholder: placeholder, readOnly: readOnly, plugins: plugins })))));
}
exports.default = ContentEditor;
ContentEditor.ControlButton = components_1.ContentEditorControlButton;
ContentEditor.Controls = components_1.ContentEditorControls;
ContentEditor.Submit = components_1.ContentEditorSubmit;
ContentEditor.Header = components_1.ContentEditorHeader;
//# sourceMappingURL=index.js.map